import axios from 'axios';

const getUser = () => axios.get('/user');
const hasFornecedor = () => axios.get('/user/has-fornecedor');
const aceitarTermo = () => axios.put('/user/aceitar-termo', {});

export default {
  getUser,
  hasFornecedor,
  aceitarTermo,
};
